 //const baseURL=`http://localhost:5453/`;
// const baseURL=`http://154.210.206.162:5453/`;
const baseURL=`/`;
export {baseURL};

const gamesApi=`${baseURL}api/content`;
export {gamesApi};

const loginApi=`${baseURL}api/login`;
export {loginApi};